<template>
  <header :class="`site-header ${variant}`" vb-background-extra1>
    <b-container>
      <div class="site-header__wrapper">
        <div class="site-header__logo">
          <slot name="logo" />
        </div>
        <div class="site-header__custom-logo">
          <custom-logo v-if="!is_mobile()" />
        </div>
        <div class="site-header__navigation" v-if="show_navigation">
          <slot name="navigation">
            <navigation :direction="'row'" />
          </slot>
        </div>
        <div class="site-header__panel" v-if="show_panel">
          <slot name="panel">
            <panel :variant="variant" />
          </slot>
        </div>
      </div>
    </b-container>
  </header>
</template>

<script>
import Panel from './panel.vue'
import Navigation from "./navigation.vue";
import CustomLogo from '@/components/customizations/custom-logo'

export default {
  name: "site-header",

  components: {
    'panel': Panel,
    'navigation': Navigation,
    'custom-logo': CustomLogo,
  },

  props: {
    variant: {
      type: String,
      default: 'light',
    }
  },

  data() {
    return {};
  },

  computed: {

    show_navigation() {
      return !this.is_authenticated() && !this.is_mobile()
    },

    show_panel() {
      return this.is_authenticated() || this.is_mobile()
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .site-header {
    user-select: none;
    position: relative;
    z-index: 200;

    &.dark {
      background: $primary;
    }

    &.white {
      background: $white;
    }

    &__wrapper {
      display: flex;
      align-items: center;
      padding: $grid-gutter-20 0;
    }

    &__logo {
      display: flex;
      align-items: center;
      flex: 1;
    }

    &__custom-logo {
      margin-right: $grid-gutter-width;

      &:empty {
        display: none;
      }
    }

    &__navigation {
      background-color: $white;
      border-radius: 50px;
      padding: 16px 15px; // Adjusted padding for better alignment
    }

    @media print {
      display: none;
    }
  }

</style>